import i18n from 'i18next';

// The app's FR/EN toggle should drive how dates are written, but a bare
// toLocaleString() / toLocaleDateString() uses the BROWSER's locale instead.
// A French user on an English browser therefore saw English-formatted dates
// everywhere, ignoring the language they picked. (The times themselves were
// always right — these render in the viewer's own timezone.)
//
// Reads the live i18next singleton rather than taking a hook, so it works in
// module-level helpers as well as inside components.
export const dateLocale = () =>
    (i18n.language && i18n.language.startsWith('fr') ? 'fr-CA' : 'en-CA');

export default dateLocale;
